<template>
  <div
    ref="scrollableContainerRef"
    class="no-scrollbar flex gap-2 overflow-auto px-4"
  >
    <button
      v-for="airline of airlines"
      :key="airline.iata"
      ref="airlineButtonsRef"
      type="button"
      class="bg-background-neutral-secondary flex min-w-fit items-center gap-2 rounded-3xl border p-2 transition duration-500"
      :class="[
        selectedAirline?.iata === airline.iata
          ? 'js-active-airline border-background-positive-primary'
          : 'border-situational-lightgrey',
      ]"
      @click="emit('onAirlineClick', airline)"
    >
      <AirlineIcon :airline="airline" />
      <span class="text-text-neutral-primary text-nowrap text-sm">
        {{ airline.title }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { ref, toRef } from 'vue';
  import { AirlineIcon, useHorizontalScrollToActive } from 'freedom-shared';

  import type { directFlightsTypes } from '@/widgets/direct-flights';

  const props = defineProps<{
    airlines: directFlightsTypes.Airline[];
    selectedAirline: directFlightsTypes.Airline | null;
  }>();

  const emit = defineEmits<{
    onAirlineClick: [airline: directFlightsTypes.Airline];
  }>();

  const scrollableContainerRef = ref<HTMLElement | null>(null);
  const airlineButtonsRef = ref<Array<HTMLButtonElement> | null>(null);

  useHorizontalScrollToActive(scrollableContainerRef, airlineButtonsRef, {
    activeClass: 'js-active-airline',
    items: toRef(props, 'airlines'),
  });
</script>
